module.exports = __webpack_public_path__ + "img/3.0d4780f7.png";